import { EventEmitter, Injectable } from '@angular/core';
import { Widget, WidgetMap, WidgetMapType } from '../../../models/widget';
import { WidgetMapService } from '../../widget-map.service';

@Injectable()

export class MapEditorInstance {
  map: WidgetMap;
  mouseClick: EventEmitter<any> = new EventEmitter<any>();
  ready: EventEmitter<boolean> = new EventEmitter<boolean>();
  snapping: boolean = true;

  constructor(private mapService: WidgetMapService) {
  }

  init(map: WidgetMap) {
    this.map = map;
  }

  getPoints(): any[] {
    let points = [];
    this.map.regions.forEach(region => {
      region.points.forEach(p => {
        points.push(p);
      })
    });

    return points;
  }

  loadMap(widget: Widget, mapId: number) {
    if (!widget || !mapId) {
      return;
    }

    //this.projectMaps = this.widget.maps;

    this.mapService.find(widget, mapId).subscribe(map => {
      if (map.type === WidgetMapType.Objects) {

      }

      this.map = map;

      console.log('map loaded');

      this.ready.emit(true);
    });
  }

  triggerMouseClick(e) {
    this.mouseClick.emit(e);
  }

  reload() {

  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/map-editor.instance.ts